export default __webpack_public_path__ + "9d2bbde416583cfa5cb30c995b41f732.ttf";